<!-- 返单、审核表单 -->
<template>
    <div class="layui-colla-two">
        <div class="layui-colla-item layui-colla-two-item" v-if="editRow.BACK_ORDER_TIME">
            <h2 class="layui-colla-title">返单信息</h2>
            <div class="layui-colla-content layui-show">
                <div class="layui-form-item-one">
                    <div class="layui-form-item">
                        <label class="layui-form-label">返单时间：</label>
                        <label class="layui-form-label right">{{editRow.BACK_ORDER_TIME}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">返单工程师：</label>
                        <label class="layui-form-label right">{{editRow.BACK_ORDER_TIME ? editRow.ENGINEER_ID_DESC : ''}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">返单类型：</label>
                        <label class="layui-form-label right">{{editRow.BACK_ORDER_TYPE_DESC}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">返单原因：</label>
                        <label class="layui-form-label right textarea">{{editRow.BACK_ORDER_REASON}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="layui-colla-item layui-colla-two-item" v-if="editRow.REVIEW_TIME || editable">
            <h2 class="layui-colla-title">返单审批</h2>
            <div class="layui-colla-content layui-show">
                <div class="layui-form-item-one">
                    <div class="layui-form-item">
                        <label class="layui-form-label"><span class="x-red" v-if="editable">*</span>审核结果：</label>
                        <label class="layui-form-label right" v-if="!editable">{{editRow.REVIEW_TYPE_DESC}}</label>
                        <div class="layui-input-inline" style="width: 60%" v-if="editable">
                            <layui-radio
                                v-model="editRow.REVIEW_TYPE"
                                name="REVIEW_TYPE">
                                <input type="radio" value="1" title="通过" />
                                <input type="radio" value="2" title="不通过" />
                            </layui-radio>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label"><span class="x-red" v-if="editable">*</span>审核人员：</label>
                        <label class="layui-form-label right" v-if="!editable">{{editRow.REVIEW_USERID}}</label>
                        <div class="layui-input-inline" style="width: 60%" v-if="editable">
                            <input
                                type="text"
                                v-model="editRow.REVIEW_USERID"
                                autocomplete="off"
                                class="layui-input"
                                name="REVIEW_USERID"
                                placeholder="请输入审核人员"/>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">审核时间：</label>
                        <label class="layui-form-label right" v-if="!editable">{{editRow.REVIEW_TIME}}</label>
                        <div class="layui-input-inline" style="width: 60%" v-if="editable">
                            <layui-datetime :showNewDate="true" name="REVIEW_TIME" v-model="editRow.REVIEW_TIME" placeholder="审核时间"></layui-datetime>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">审核意见：</label>
                        <label class="layui-form-label right textarea" v-if="!editable">{{editRow.REVIEW_OPTION}}</label>
                        <div class="layui-input-inline" style="width:60%" v-if="editable">
                            <textarea v-model="editRow.REVIEW_OPTION" class="layui-textarea"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            editRow: {
                default: () => ({}),
                type: Object
            },
            enabled: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                editable:false,
            }
        },
        mounted () {
            this.editable = this.enabled;
        },
        watch:{
            enabled:{//深度监听，可监听到对象、数组的变化
                handler(val, oldVal){
                    this.editable = val;
                },
                deep:true //true 深度监听
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/workOrder/detailForm/backOrderForm.vue